import { z } from 'zod';
import { REQUIRED, MUST_BE_THE_DIFFERENCE } from '@/components/Form/validation';

export const replaceApproverSchema = z
  .object({
    replace: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.trim().length > 0, REQUIRED),
    to: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.trim().length > 0, REQUIRED),
    replace_in_companies: z.boolean().optional(),
  })
  .refine(
    (data) => {
      // Ensure the two approvers are different
      if (data.replace && data.to) {
        return data.replace !== data.to;
      }
      return true;
    },
    {
      message: MUST_BE_THE_DIFFERENCE,
      path: ['to'],
    },
  );

export type ReplaceApproverFormData = z.infer<typeof replaceApproverSchema>;
